module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/icon-align-to-right.6bb8deefe8b0361b2401672a5eea9c4e.svg";